import { render, staticRenderFns } from "./Box6.vue?vue&type=template&id=8cfbac38&scoped=true&"
import script from "./Box6.vue?vue&type=script&lang=js&"
export * from "./Box6.vue?vue&type=script&lang=js&"
import style0 from "./Box6.vue?vue&type=style&index=0&id=8cfbac38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfbac38",
  null
  
)

export default component.exports